import http from "../axios";

const homeworkAnalysisApi = {
    /**
     * 平台作业列表
     * @param {*} data 
     * @returns 
     */
    platformHomework(data){
        return http({
            url: "/Principal/PlatForm",
            method: "POST",
            data: data,
          });
    },
    //教师明细列表
    homeworkDetail(data){
        return http({
            url:"/Principal/PlatFormDetail",
            method: "POST",
            data: data,
        })
    },
    // AI列表
    aiList(data){
        return http({
            url: "/Principal/AiCard",
            method: "POST",
            data: data,
          });
    },
    // AI教师明细
    aiDetail(data){
        return http({
            url: "/Principal/AiCardDetail",
            method: "POST",
            data: data,
          });
    }
}

export default homeworkAnalysisApi